<div *ngIf="isWindowOpen()" [class.pa-chat-window-maximized]="maximized" class="pa-chat-window">
    <div class="pa-chat-window-header">
        <div class="pa-chat-window-header-title">
            {{widgetTitle}}
        </div>
        <div (click)="closeWindow()" class="pa-chat-window-header-close">
            <div class="pa-chat-window-header-icon pa-chat-window-header-icon-close"></div>
        </div>
        <div (click)="toggleMaximation()" [class.pa-chat-window-header-maximize-visible]="showMaximize"
             class="pa-chat-window-header-maximize">
            <div [ngClass]="(maximized)?'pa-chat-window-header-icon-restore':'pa-chat-window-header-icon-maximize'"
                 class="pa-chat-window-header-icon"></div>
        </div>
        <div class="pa-chat-window-icon">
            <ng-content select="[headericon]"></ng-content>
        </div>
        <div class="pa-chat-window-action">
            <ng-content select="[headeraction]"></ng-content>
        </div>
    </div>
    <div class="pa-chat-widget-container">
        <ng-content></ng-content>
    </div>
</div>
<div [class.pa-chat-widget-avatar-container-notifying]="showNotification"
     [class.pa-chat-widget-avatar-container-open]="isWindowOpen()"
     class="pa-chat-widget-avatar-container">
    <div class="pa-chat-widget-avatar-notification">
        <div (click)="toggleWindow()" class="pa-chat-widget-avatar-notification-slider">
            {{notificationMessage}}
        </div>
    </div>
    <div (click)="toggleWindow()" class="pa-chat-widget-avatar">
    </div>
</div>
<div [class.pa-chat-widget-maximized-shadow-maximized]="maximized"
     [class.pa-chat-widget-maximized-shadow-open]="isWindowOpen()"
     class="pa-chat-widget-maximized-shadow"></div>
